import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import "../../../../styles/ExpressionBuilder.css";

/**
 * Text input component for expression rule values
 * @param {Object} rest - Props to pass to Input component
 * @returns {JSX.Element} Text input component
 * @author Abhishek Dhillon
 * @parent ValueInput
 */
const TextInput = ({ ...rest }) => {
  return (
    <Input 
      {...rest} 
      id='value-input-text'
      className='expression-builder-w-100'
      placeholder="Enter text value"
    />
  );
};

export default TextInput;
